//=================================================
//    summary: DCP Account 分頁 -- Hook
//
//    remarks: 000 Tim 2021/11/12 Create
//================================================
import React, { useState, useEffect } from 'react'
import cssAccount from './Account.module.scss'

import EmailVerified from '../../../../Home/Units/EmailVerified/EmailVerified'
import {GlobalLibs, NetworkLibs, ClientGatewayInPackage, PackageVariablesLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
// #endregion Member Variables


const COMP_NAME = "Account"

function Account(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [isShowEmailVerified, setIsShowEmailVerified] = useState(false)
    // #endregion Init State

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 編輯個人檔案
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function EditProfileOnTapHandler()
    {
        console.log(COMP_NAME + ".EditProfileOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strInApp4QueryString = window.Globals.GetInAppQueryString4BCClass()

        let strWebSiteUrl = PackageVariablesLibs.SysConfig.ClassWebSiteUrl
        let strArgList = "Credential=" + window.gSession.Acc.Credential
        strArgList += "&func=accountprofile"
        strArgList += strInApp4QueryString
        let strUrl = strWebSiteUrl + "?" + strArgList
        
        OpenWebPage(strUrl)
    } // end of EditProfileOnTapHandler

    /*===========================================
    summary: 點選 email 驗證 (這個流程 可能要調整...) 
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function EmailVerifyOnTapHandler()
    {
        console.log(COMP_NAME + ".EmailVerifyOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (window.gSession.Acc.Profile) !== 'undefined') &&
            (window.gSession.Acc.Profile !== null) &&
            (typeof (window.gSession.Acc.Profile.Email) !== 'undefined') &&
            (window.gSession.Acc.Profile.Email !== null) &&
            (window.gSession.Acc.Profile.Email !== '')
            )
        {
            mobjCallParam = {
                "AccountID": window.gSession.Acc.ID,
                "EmailAddr": window.gSession.Acc.Profile.Email,                              // window.gSession.Acc.Profile.Email // "jeff.lin@betterchinese.com"
                "LoginName": window.gSession.Acc.LoginName,         // window.gSession.Acc.LoginName // "jeff.lin@betterchinese.com"
                "SysType": window.gSession.App.SysType
            }
            SendAccountVerifyEmail()
        }
        else
        {
            setIsShowEmailVerified(true)
        }
    } // end of EmailVerifyOnTapHandler

    /*===========================================
    summary: 點選 改變密碼
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ChangePasswordOnTapHandler()
    {
        console.log(COMP_NAME + ".ChangePasswordOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strInApp4QueryString = window.Globals.GetInAppQueryString4BCClass()

        let strWebSiteUrl = PackageVariablesLibs.SysConfig.ClassWebSiteUrl
        let strArgList = "Credential=" + window.gSession.Acc.Credential
        strArgList += "&func=changepassword"
        strArgList += strInApp4QueryString
        let strUrl = strWebSiteUrl + "?" + strArgList
        
        OpenWebPage(strUrl)
    } // end of ChangePasswordOnTapHandler

    /*===========================================
    summary: 點選 刪除帳號 (App)
    remarks: 000 Tim 2022/06/13 Create
    ===========================================*/
    function DeleteMyAccountOnTapHandler()
    {
        console.log(COMP_NAME + ".DeleteMyAccountOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strInApp4QueryString = window.Globals.GetInAppQueryString4BCClass()

        let strWebSiteUrl = PackageVariablesLibs.SysConfig.ClassWebSiteUrl
        let strArgList = "Credential=" + window.gSession.Acc.Credential
        strArgList += "&func=deleteaccount"
        strArgList += strInApp4QueryString 
        let strUrl = strWebSiteUrl + "?" + strArgList
        
        OpenWebPage(strUrl)
    } // end of DeleteMyAccountOnTapHandler
    // #endregion OnTapHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowEmailVerified")
        {
            setIsShowEmailVerified(false)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region AlertCallback
    /*===========================================
    summary: 送出 Email 成功 提示 Callback
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function SentEmailSuccessAlertCallback()
    {
        setIsShowEmailVerified(false)
    } // end of SentEmailSuccessAlertCallback
    // #endregion AlertCallback

    // #region Other Functions
    /*===========================================
    summary: 另開 Web頁面 
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/07/06 支援 OPEN_SAFARI_VIEW
    ===========================================*/
    function OpenWebPage(Url)
    {
        const FUNC_NAME = OpenWebPage.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", Url)

        if (!window.gSession.App.InApp)
        {
            // In Web
            window.open(Url)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            let intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, window.gConst.OPEN_SAFARI_VIEW_APP_VER)
            let intAction = -1
            let strQueryString = ""

            if (intCheckResult === -1)
            {
                // App版號 v3.1.0 b1 以前
                intAction = window.gConst.ACTION_OPEN_BROWSER
                strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(Url)

                console.log(COMP_NAME + ".OpenWebPage CallApp OpenBrowser strQueryString: ", strQueryString)
            } // end of if (intCheckResult === -1)
            else
            {
                // App版號 v3.1.0 b2 之後
                intAction = window.gConst.ACTION_OPEN_SAFARI_VIEW
                strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&Url=" + encodeURIComponent(Url)

                console.log(COMP_NAME + ".OpenWebPage CallApp OpenSafariView strQueryString: ", strQueryString)
            } // end of else

            // window.gSession.App.AppCallbackRef = null
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of OpenWebPage
    // #endregion Other Functions

    // #region Web Service After Process
    /*===========================================
    summary: 送出 帳號認證 Email 後 的 流程
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function SendAccountVerifyEmailAfterProcess ()
    {   
        console.log(COMP_NAME + ".SendAccountVerifyEmailAfterProcess")
        
        // 跳出寄送完成的訊息
        let objAlertObject = {
            Header: null,
            Body: window.gAppUI.LBL_SentVerifySuccessed,
            ShowCloseButton: false,
            CallbackRef: SentEmailSuccessAlertCallback,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)

        mobjCallParam = null
    } // end of SendAccountVerifyEmailAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 送出 帳號認證 Email
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function SendAccountVerifyEmail ()
    {
        let objRetryFuncRef = SendAccountVerifyEmail
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SendAccountVerifyEmailCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SendAccountVerifyEmail)

            let objCallData = {
                "Func": "SendAccountVerifyEmail",
                "AccountID": mobjCallParam.AccountID,
                "EmailAddr": mobjCallParam.EmailAddr,
                "LoginName": mobjCallParam.LoginName,
                "SysType": mobjCallParam.SysType
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SendAccountVerifyEmail

    /*===========================================
    summary: 送出 帳號認證 Email Callback
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function SendAccountVerifyEmailCallback (Return)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SendAccountVerifyEmail_No
        let strErrorTitle = window.gAppUI.ERR_SendAccountVerifyEmail_Title
        let strErrMsg = window.gAppUI.ERR_SendAccountVerifyEmail_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_EXIST_EMAIL_WITH_OTHER_ACCOUNTID: // -140186,  // 你輸入的信箱已存在 158
                    strErrMsg = window.gAppUI.ERR_VEExistEmailWithOtherAccountID_Msg
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_NOT_YET_CLICK_VERIFY_LINK: // -140171,  // 再次寄送認證信到你的信箱 153
                    strErrMsg = window.gAppUI.ERR_VENotYetClickVerifyLink_Msg
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_ALREADY_VERIFIED: // -140172,  // 此連結已驗證過 154
                    strErrMsg = window.gAppUI.ERR_VEAlreadyVerified_Msg
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SendAccountVerifyEmailCallback: ErrNo: ", Return.ErrNo)
            console.log("SendAccountVerifyEmailCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SendAccountVerifyEmailCallback Return.Data: ", Return.Data)

            SendAccountVerifyEmailAfterProcess()
        }
    } // end of SendAccountVerifyEmailCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Content Memo Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentMemoRow()
    {   
        return(
            <div className={cssAccount.divMemo}>
                {window.gAppUI.LBL_SettingsAccountMemo}
            </div>
        )
    } // end of ComponentContentMemoRow
                
    /*===========================================
    summary: 刪除帳號 Row 顯示Component  
    remarks: 000 Tim 2022/06/13 Create
    ===========================================*/
    function ComponentDeleteMyAccountRow()
    {   
        if (window.gSession.App.InApp)
        {
            return(
                <div className={cssAccount.divRowMain}>
                    <div className={cssAccount.divRowTitle}>
                        {window.gAppUI.LBL_Account}
                    </div>
                    <div className={cssAccount.btnDeleteMyAccount} onClick={() => DeleteMyAccountOnTapHandler()}>
                        {window.gAppUI.LBL_DeleteMyAccount}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentDeleteMyAccountRow

    /*===========================================
    summary: Content Password Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentPasswordRow()
    {   
        return(
            <div className={cssAccount.divRowMain}>
                <div className={cssAccount.divRowTitle}>
                    {window.gAppUI.LBL_Password}
                </div>
                <div className={cssAccount.btnChangePassword} onClick={() => ChangePasswordOnTapHandler()}>
                    {window.gAppUI.LBL_ChangePassword}
                </div>
            </div>
        )
    } // end of ComponentContentPasswordRow

    /*===========================================
    summary: Content Country Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentCountryRow()
    {   
        let intCountryIndex = parseInt(window.gSession.Acc.Profile.Country) - 1
        let strCountry = window.garrCountry[intCountryIndex].BackendID

        return(
            <div className={cssAccount.divRowMain}>
                <div className={cssAccount.divRowTitle}>
                    {window.gAppUI.LBL_Country}
                </div>
                <div className={cssAccount.divRowText}>
                    {strCountry}
                </div>
            </div>
        )
    } // end of ComponentContentCountryRow

    /*===========================================
    summary: Content Gender Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentGenderRow()
    {   
        let strGender = ""
        if (window.gSession.Acc.Profile.Gender === 'F')
        {
            strGender = window.gAppUI.LBL_Female
        }
        else
        {
            strGender = window.gAppUI.LBL_Male
        }

        return(
            <div className={cssAccount.divRowMain}>
                <div className={cssAccount.divRowTitle}>
                    {window.gAppUI.LBL_Gender}
                </div>
                <div className={cssAccount.divRowText}>
                    {strGender}
                </div>
            </div>
        )
    } // end of ComponentContentGenderRow
                
    /*===========================================
    summary: Content Email Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentEmailRow()
    {   
        let objEmailVerifyButton = null
        if (window.gSession.Acc.EmailVerified === window.gEmailVerifyEnum.NotVerify)
        {
            objEmailVerifyButton =  <div className={cssAccount.btnEmailVerify} onClick={() => EmailVerifyOnTapHandler()}>
                                        {window.gAppUI.BTN_Verify}
                                    </div>
        }

        return(
            <div className={cssAccount.divRowMain}>
                <div className={cssAccount.divRowTitle}>
                    {window.gAppUI.LBL_Email}
                </div>
                <div className={cssAccount.divRowText}>
                    {window.gSession.Acc.Profile.Email}
                </div>

                {objEmailVerifyButton}
            </div>
        )
    } // end of ComponentContentEmailRow

    /*===========================================
    summary: Content Value Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentValueRow( {Title, Value} )
    {   
        return(
            <div className={cssAccount.divRowMain}>
                <div className={cssAccount.divRowTitle}>
                    {Title}
                </div>
                <div className={cssAccount.divRowText}>
                    {Value}
                </div>
            </div>
        )
    } // end of ComponentContentValueRow

    /*===========================================
    summary: Content Title Row 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentContentTitleRow()
    {   
        return(
            <div className={cssAccount.divContentTitleRow}>
                <div className={cssAccount.divContentTitle}>
                    {window.gAppUI.LBL_UserProfile}
                </div>

                <div className={cssAccount.btnEditProfile} 
                        onClick={() => EditProfileOnTapHandler()}>
                    <div className={cssAccount.divEditProfileIcon}/>
                    <div className={cssAccount.divEditProfileText}>
                        {window.gAppUI.LBL_Edit}
                    </div>
                </div>
            </div>
        )
    } // end of ComponentContentTitleRow
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Email驗證 提示視窗 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderEmailVerifiedWrapper(StateIsShowEmailVerified)
    {
        if (StateIsShowEmailVerified)
        {
            return(
                <EmailVerified CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderEmailVerifiedWrapper

    /*===========================================
    summary: Render Account 內容 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                <ComponentContentTitleRow />

                <div className={cssAccount.divTitleLine}/>

                <ComponentContentValueRow Title={window.gAppUI.LBL_FirstName} 
                    Value={window.gSession.Acc.Profile.FirstName}/>

                <ComponentContentValueRow Title={window.gAppUI.LBL_LastName} 
                    Value={window.gSession.Acc.Profile.LastName}/>

                <ComponentContentEmailRow />

                <ComponentContentGenderRow />

                <ComponentContentCountryRow />

                <ComponentContentPasswordRow />

                <ComponentDeleteMyAccountRow />

                <div className={cssAccount.divTitleLine}/>

                <ComponentContentMemoRow />
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                {RenderContentWrapper()}
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}

            {RenderEmailVerifiedWrapper(isShowEmailVerified)}
        </>
    )
    // #endregion Render
}
export default Account